import React, {useState} from 'react';
import {Button, Modal, Row, Col} from 'react-bootstrap';
import PropTypes from 'prop-types';
import {BeatLoader} from 'react-spinners';
import {withApollo} from 'react-apollo';
import {withTranslation} from 'react-i18next';
import styled from 'styled-components';

const CenteredRow = styled(Row)`
  text-align: center;
`;

const ModelButton = styled(Button)`
  height: 40px;
  width: auto;
`;

const StyledHeader = styled(Modal.Header)`
  background-color: rgb(201, 0, 95);
  color: white;
  border-top-left-radius: 3px;
  border-top-right-radius: 3px;
`;

const StyledTitle = styled(Modal.Title)`
  font-size: 20px;
`;

const ColMargedButtom = styled(Col)`
  margin-bottom: 20px;
`;

const ConfirmModal = ({cancelBtn, confirmBtn, title, size, children, displayError, t, mutation, extraContent}) => {

  const [loading, setLoading] = useState(false);
  const [visible, setVisible] = useState(false);
  const [error, setError] = useState(null);

  const runMutation = () => {
    setLoading(true);
    mutation()
      .then(() => {
        setLoading(false);
        setVisible(false);
      })
      .catch(error => {
        console.error(error);
        setLoading(false);
        setError(error);
      });
  };

  return (
    <>
      <Modal
        show={visible}
        onHide={() => !loading && setVisible(false)}
        size={size}
        dialogClassName={size === 'xl' ? 'modal-90w' : ''}
      >
        <StyledHeader closeButton>
          <StyledTitle>{title}</StyledTitle>
        </StyledHeader>
        <Modal.Body>
          <CenteredRow>
            {loading ? (
              <BeatLoader color="#123abc" />
            ) : (
              <>
                {extraContent && (
                  <ColMargedButtom xs={12}>
                    {extraContent}
                  </ColMargedButtom>
                )}
                <Col xs={6}>
                  <ModelButton className="title-btn" onClick={runMutation}>
                    {t(confirmBtn)}
                  </ModelButton>
                </Col>
                <Col xs={6}>
                  <ModelButton className="cancel-btn" onClick={() => setVisible(false)}>
                    {t(cancelBtn)}
                  </ModelButton>
                </Col>
                <Col xs={12} style={{marginTop: '15px'}}>
                  {error && displayError(error)}
                </Col>
              </>
            )}
          </CenteredRow>
        </Modal.Body>
      </Modal>
      {children(() => setVisible(true))}
    </>
  );
};

ConfirmModal.defaultProps = {
  size: 'lg',
  cancelBtn: 'cancel',
  confirmBtn: 'confirm',
  title: 'Confirmation',
  displayError: () => {},
  extraContent: null,
};

ConfirmModal.propTypes = {
  size: PropTypes.string,
  cancelBtn: PropTypes.string,
  confirmBtn: PropTypes.string,
  title: PropTypes.string,
  children: PropTypes.func.isRequired,
  displayError: PropTypes.func,
  extraContent: PropTypes.any,
};

export default withApollo(withTranslation('common')(ConfirmModal));
